var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pa-1",staticStyle:{"overflow":"hidden"},attrs:{"flat":""}},[_c('custom-tabs',{attrs:{"tab-items":[
      {
        text: this.$t('create_podcast'),
        icon: 'music-circle-outline',
        value: 'voice',
      },
      { text: this.$t('add_link'), icon: 'music-note-plus', value: 'files' },
      {
        text: this.$t('upload_file'),
        icon: 'archive-music-outline',
        value: 'video',
      },
      {
        text: this.$t('file_list'),
        icon: 'folder-music-outline',
        value: 'sound',
      },
    ],"grow":""},scopedSlots:_vm._u([{key:"staticItems",fn:function(){return [_c('v-tab-item',{staticStyle:{"position":"relative"}},[_c('v-card',{staticClass:"pa-2",staticStyle:{"opacity":"1"},attrs:{"flat":""}},[_c('create-audio',{on:{"onVoiceCreated":_vm.handleVoiceCreated}})],1)],1),_c('v-tab-item',[_c('add-link-audio',{attrs:{"audioSelects":_vm.audioSelects}})],1),_c('v-tab-item',[_c('upload-audio',{attrs:{"category":_vm.category},on:{"update":_vm.getSound},model:{value:(_vm.tabs),callback:function ($$v) {_vm.tabs=$$v},expression:"tabs"}})],1),_c('v-tab-item',[_c('audio-list',{attrs:{"category":_vm.category,"audios":_vm.audios,"audioSelects":_vm.audioSelects,"loading":_vm.loading,"dialog":_vm.dialog},model:{value:(_vm.fileComputed),callback:function ($$v) {_vm.fileComputed=$$v},expression:"fileComputed"}})],1)]},proxy:true}]),model:{value:(_vm.tabs),callback:function ($$v) {_vm.tabs=$$v},expression:"tabs"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }